import { useState, useEffect } from 'react';

function BackToTopButton({ setActiveLink }) {
  const [ showComponent, setShowComponent ] = useState(false);

  const handleBackToTopClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    setActiveLink('HOME');
  }

  useEffect(() => {
    const handleScroll = () => {
      const scrollThreshold = 500;
      const shouldShowComponent = window.scrollY > scrollThreshold;
      setShowComponent(shouldShowComponent);
    }

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return (
    <div>
      {showComponent && <button className='back-to-top-btn' onClick={handleBackToTopClick}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
  <path fillRule="evenodd" d="M7.646 2.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 3.707 2.354 9.354a.5.5 0 1 1-.708-.708z"/>
  <path fillRule="evenodd" d="M7.646 6.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 7.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"/>
</svg></button>}
    </div>
  )
}

export default BackToTopButton;